import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Input,
  Dropdown,
  ButtonGroup,
  Checkbox,
  Icon,
  Label,
} from "semantic-ui-react";
import { ObligacionesDropdown } from "../../../../../utils/obligations";
import { cleanRut, formatMoney, formatNewMoney, formatRut, rutWithDash } from "../../../../../utils/formatter";
import { currencyOptionsWithSpecials } from "../../../../../utils/currencies";
import { CreateObligation } from "../../../../../graphql/obligations";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";
import { GenerateMatch, GenerateMultipleMatch } from "../../../../../graphql/conciliacion";
import { GetAgendas, CreateAgenda, AgendaByRut } from "../../../../../graphql/agenda";
import {
  EditObligation,
  DeleteDocument,
} from "../../../../../graphql/taxDocument";
import { useDispatch, useSelector } from "react-redux";
import { ObligationTorpedo, parseObligation } from "./functions";
import { importAlertState } from "../../../../../redux/actions/alert";
import { importOpenSidebar } from "../../../../../redux/actions/openSidebar";
import { importUpdateCashflowNeeded, importUpdateNeeded } from "../../../../../redux/actions/flujocaja";
import { importNewModal } from "../../../../../redux/actions/newModal";
import CurrencyDropdown from "../../currencyDropdown";
import moment from "moment";
import "../../../../../scss/_semanticForms.scss";
import "./style.scss";
import { DocumentType, TransactionType } from "src/utils/enum";
import { setUpdateDocuments } from 'src/redux/actions/documentostributarios'
import { importUpdateCashFlow } from 'src/redux/actions/flujocaja'
import CashflowAreaDropdown from "../../formTypes/cashflowAreaDropdown";
import SelectorEERR from "../../formTypes/selectorEERR";
import { FULL_ACCESS_PLANS, Plans } from "src/utils/plans";
import { importUpdateNominaData } from "src/redux/actions/proveedores";
import { updateConcilieantionRatio } from "src/redux/actions/dashboard";
import { GetIndicatorByDate } from "src/graphql/indicators";
import { FindCompanyName } from 'src/graphql/addCompany'
import { importEERRUpdateNeeded } from "src/redux/actions/eerr";
import CustomModal from "../../../../configuracion/components/customModal";
import { getDocumentsInNominaInfo, useNominaGuardModalBodyClass } from "src/utils/documentNominaGuard";

const baseOptions = {
  id: "add",
  key: "add",
  value: "add",
  text: "Crear Contraparte",
  label: "(+)",
};

const tipoRecurrencia = [
  { value: "unico", text: "Obligación Única" },
  { value: "recurrente", text: "Obligación Recurrente" },
]

const repeatOptions = [
  { text: "Cada 7 días", value: 7 },
  { text: "Cada 15 días", value: 15 },
  { text: "Cada 30 días", value: 30 },
  { text: "Cada 45 días", value: 45 },
  { text: "Cada 60 días", value: 60 },
  { text: "Cada 90 días", value: 90 },
];


const CrearObligacion = ({ options: opciones }) => {

  const dispatch = useDispatch();
  const { isCrearObligacionBlocked } = useBlockedFeatures();
  const [contacts, setContacts] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [isAmountDisabled, setIsAmountDisabled] = useState(false)
  const [nameFound, setNameFound] = useState("")
  const [issuer, setIssuer] = useState({});
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const [showNominaGuardModal, setShowNominaGuardModal] = useState(false);
  useNominaGuardModalBodyClass(showNominaGuardModal);

  const { roles } = useSelector((state) => state.auth)

  const { openSidebar: { editData, source, type, selected, setSelected, fastObligation = false } } = useSelector((state) => state.openSidebar);
  const { selectedCompany: { id: companyId, plan: plan } } = useSelector((state) => state.companyList)

  const companyPlans = plan || [];

  const [variables, setVariables] = useState({
    isReceived: editData?.meta?.isReceived ?? true,
    currency: editData?.currencyType || "CLP",
    tipo: "unico",
    documentDate: editData?.documentDate ? moment(editData?.documentDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
    desdeDate: null,
    hastaDate: null,
    repeat: 7,
    rate: 1,
    isMassive: false,
  })

  const currencyDate = moment().isBefore(moment(variables.documentDate, 'YYYY-MM-DD'))
    ? moment().format("DD/MM/YYYY")
    : moment(variables.documentDate, 'YYYY-MM-DD').format("DD/MM/YYYY")

  const { executeMutation: createAgenda } = CreateAgenda()
  const { executeMutation: generateMatch } = GenerateMatch()
  const { executeMutation: createObligation } = CreateObligation()
  const { reexecuteMutation: UpdateObligation } = EditObligation()
  const { executeMutation: deleteDocuments, fetching: deleteLoading } = DeleteDocument()
  const { executeMutation: generateMultipleMatch } = GenerateMultipleMatch()
  const getIndicatorByDate = GetIndicatorByDate(currencyDate);
  
  // Solo ejecutar AgendaByRut si hay un RUT válido
  const rutForAgenda = editData?.meta?.isReceived ? editData?.meta?.issuerId : editData?.meta?.receiverId
  const validRut = rutForAgenda && typeof rutForAgenda === 'string' && rutForAgenda.trim() !== '' ? rutForAgenda : ''
  const { data: agendaData, fetchingAgendaData } = AgendaByRut(validRut, companyId, '')

  const contactData = agendaData?.AgendaByRut
  const [getAgendasInput, setGetAgendasInput] = useState({
    input: { companyId },
    pagination: { limit: 30 },
    search,
  })
  const { data, reexecuteQuery, fetching } = GetAgendas(getAgendasInput)
  const { executeMutation: findCompanyName } = FindCompanyName();

  useEffect(() => {
    const handler = setTimeout(() => {
      reexecuteQuery({ requestPolicy: 'network-only' });
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [getAgendasInput]);

  useEffect(() => {
    if (!contactData || variables?.issuerId) return;

    const contactId = contactData?.id || contactData?._id;
    const rut = contactData?.worldWide === 'cl' ? formatRut(contactData?.rut) : contactData?.rut;
    const nameAndRut = `${rut} ${contactData?.name}`;
    const label =
      contactData?.isClient && contactData?.isProvider
        ? "Cliente - Proveedor"
        : contactData?.isClient
          ? "Cliente"
          : "Proveedor";
    
    const issuerObj = {
      id: contactId,
      key: contactId,
      value: contactId,
      text: nameAndRut,
      name: contactData?.name,
      rut: contactData?.rut,
      label,
    };
    
    setIssuer(issuerObj);
    setVariables({ ...variables, issuerId: contactId })
  }, [contactData])

  useEffect(() => {
    if (getIndicatorByDate.data) {
      if (getIndicatorByDate?.data?.getIndicatorByDate) {
        setVariables({ ...variables, rate: getIndicatorByDate.data.getIndicatorByDate.exchange[variables.currency] })
      }
    }
  }, [variables.currency, variables.documentDate])

  useEffect(() => {
    if (variables.documentDate) {
      getIndicatorByDate.reexecuteQuery({ requestPolicy: 'network-only' })
    }
  }, [variables.documentDate])

  useEffect(() => {
    if (editData) {
      let DEFAULT_OBJ = {};

      if (source == "transactions") {
        const TRANS_OBJ = {
          documentDate: editData?.date
            ? moment(editData.date).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          currency: editData.currency || "CLP",
          rate: 1,
          originalAmount: editData?.remaining ? String(editData.remaining) : "",
          amount: editData?.remaining ? String(editData.remaining) : "",
          description: editData?.description ? editData.description : "",
          //type: editData ? ObligationTorpedo(editData) : "",
          type: editData?.shortcut
            ? editData.shortcut
            : ObligationTorpedo(editData) || "",
          isReceived: editData.type == TransactionType.RECIEVED ? false : true,
          fieldKey: editData?.fieldKey ? editData?.fieldKey : ""
        };

        DEFAULT_OBJ = { ...DEFAULT_OBJ, ...TRANS_OBJ };
      }

      if (source == "documents") {
        const DOCS_OBJ = {
          documentDate: editData?.documentDate
            ? moment(editData.documentDate).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          currency: "CLP",

          amount: [0, 1, "0", "1"].includes(editData?.meta.documentCode)
            ? editData?.meta.remaining - editData?.meta.taxAmount
            : editData?.meta.remaining
              ? String(editData.meta.remaining)
              : editData?.amount
                ? String(editData.amount)
                : "",
          originalAmount: [0, 1, "0", "1"].includes(editData?.meta.documentCode)
            ? editData?.meta.remaining - editData?.meta.taxAmount
            : editData?.meta.remaining
              ? String(editData.meta.remaining)
              : editData?.amount
                ? String(editData.amount)
                : "",
          description: "",
          type: type ? type : editData ? ObligationTorpedo(editData) : "",
          isReceived: editData.meta.isReceived,
          issuerId: editData.meta.isReceived
            ? editData.meta.issuerId
            : editData.meta.receiverId,
          rut: editData.meta.isReceived
            ? editData.meta.issuerId
            : editData.meta.receiverId,
          name: editData.meta.isReceived
            ? editData.meta.issuerName
            : editData.meta.receiverName,
          fieldKey: editData?.fieldKey ? editData?.fieldKey : ""
        };

        DEFAULT_OBJ = { ...DEFAULT_OBJ, ...DOCS_OBJ };
      }

      if (source == "editObligation") {
        const rut = editData.meta.isReceived ? editData.meta.issuerId : editData.meta.receiverId
        const contraparte = options.find(f => f.rut == cleanRut(rut))
        if (editData.meta?.matchs?.inMatch.length > 0 || editData.meta?.matchs?.outMatch.length > 0) setIsAmountDisabled(true)
        
        // Si la obligación tiene datos de exchange, usar originalAmount y exchangeRate de exchange
        // para que el usuario vea/edite el monto en la moneda original (UF, USD, etc.)
        const hasExchange = editData.meta?.exchange?.originalCurrency && editData.meta.exchange.originalCurrency !== 'CLP';
        const editOriginalAmount = hasExchange
          ? editData.meta.exchange.originalAmount
          : editData.meta?.originalAmount;
        const editRate = hasExchange
          ? editData.meta.exchange.exchangeRate
          : editData.meta.rate;
        const editCurrency = hasExchange
          ? editData.meta.exchange.originalCurrency
          : (editData?.currencyType || editData.meta?.currency || "CLP");
        
        const DOCS_OBJ = {
          documentDate: editData.meta?.documentDate || editData?.documentDate
            ? moment(editData.meta?.documentDate || editData?.documentDate).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          currency: editCurrency,
          amount: editData?.meta?.amount > 0 ? String(editData.meta.amount).replace(/\./g, ",") : "",
          description: editData?.description || editData?.meta?.description || (editData?.meta?.detail && editData.meta.detail[0]?.description) || "",
          type: editData.meta?.type,
          isReceived: editData.meta?.isReceived,
          referenceNumber: editData.meta.referenceNumber || "",
          rate: editRate
            ? String(editRate)
            : "",
          documentId: editData.meta.number,
          originalAmount: editOriginalAmount
            ? String(editOriginalAmount)
            : "",
          name: editData.meta.isReceived
            ? editData.meta.issuerName
            : editData.meta.receiverName,
          rut: editData.meta.isReceived
            ? editData.meta.issuerId
            : editData.meta.receiverId,
          cashflowAreaId: editData?.cashflowAreaId,
          fieldKey: editData?.fieldKey ? editData?.fieldKey : "",
          issuerId: contactData?.id || contactData?._id || '',
        };

        DEFAULT_OBJ = { ...DEFAULT_OBJ, ...DOCS_OBJ };
      }

      /* isReceived: Si existe un editData, entonces se validará si el type es SPEND, si se cumple, por defecto se creará como Por Pagar, 
      de lo contrario, será Por Cobrar, si no existe el editData, entonces se creará por defecto como Por Pagar */
      let isReceivedFromData = false;

      if (editData.selectedTransactions && editData.selectedTransactions.length > 0) {
        const transaction = editData.selectedTransactions[0];
        isReceivedFromData = transaction.type == 'SPEND'
      } else {
        isReceivedFromData = editData
          ? editData.documentType ? (editData.meta.isReceived) : (editData?.type === 'SPEND' ? true : false)
          : variables.isReceived
      }

      const newVariables = {
        ...variables, ...DEFAULT_OBJ, isReceived: isReceivedFromData
      };
      setVariables(newVariables);
    }

    if (opciones?.source == "flow") {
      setVariables({ ...variables, type: "proyeccion" })
    }
  }, []);

  useEffect(() => {
    if (!data) return;

    const agendas = data.paginatedSearchAgenda.docs;

    let parsedAgendas = [];
    
    if (agendas.length > 0) {
      parsedAgendas = agendas.map((m) => {
        const contactId = m?.id || m?._id;
        const rut = m?.worldWide === 'cl' ? formatRut(m?.rut) : m?.rut;
        const nameAndRut = `${rut} ${m?.name}`;
        const label =
          m?.isClient && m?.isProvider
            ? "Cliente - Proveedor"
            : m?.isClient
              ? "Cliente"
              : "Proveedor";
        return {
          id: contactId,
          key: contactId,
          value: contactId,
          text: nameAndRut,
          name: m?.name,
          rut: m?.rut,
          label,
        };
      });

      const newOptions = [...parsedAgendas];

      const issuerIsAdded = options.find((option) => option.key === issuer.key) !== undefined;
      const issuerIsAddOption = issuer?.key === 'add' || issuer?.value === 'add';

      if (issuerIsAdded && !issuerIsAddOption) {
        const filteredOptions = newOptions.filter(option => option.key !== issuer.key);
        setOptions([
          baseOptions,
          issuer,
          ...filteredOptions
        ]);
      } else {
        // Ensure only one 'add' option exists
        const filtered = newOptions.filter(opt => opt.key !== 'add');
        setOptions([baseOptions, ...filtered]);
      }

      const validAgendas = agendas.filter(a => a && (a.id || a._id));
      const uniqueContacts = [...contacts];
      
      validAgendas.forEach(agenda => {
        const contactId = agenda.id || agenda._id;
        if (!uniqueContacts.some(c => c && (c.id === contactId || c._id === contactId))) {
          uniqueContacts.push(agenda);
        }
      });
      
      setContacts(uniqueContacts);
    } else {
      getContraparteName();
    }

    if (data.paginatedSearchAgenda.docs.length === 1) {
      const contactId = data.paginatedSearchAgenda.docs[0].id || data.paginatedSearchAgenda.docs[0]._id;
      const newVariables = {
        ...variables,
        issuerId: contactId
      }

      setVariables(newVariables);
    } else if (data.paginatedSearchAgenda.docs.length === 0 && variables.issuerId) {
      const newVariables = {
        ...variables,
        issuerId: 'add'
      }

      setVariables(newVariables);
    }
    
    // Set issuer state if we have issuerId but issuer is not set
    if (variables.issuerId && !issuer.key && variables.issuerId !== 'add' && parsedAgendas.length > 0) {
      const matchingOption = parsedAgendas.find(opt => opt.value === variables.issuerId);
      if (matchingOption) {
        setIssuer(matchingOption);
      }
    }
  }, [companyId, editData?.id, data]);

  useEffect(() => {
    if (variables.isReceived !== undefined || variables.isReceived !== null) return
    reexecuteQuery({ requestPolicy: 'network-only' })
  }, [variables?.isReceived, loading])

  const onChange = (route, value) => {
    let newVariables = { ...variables, ...{ [route]: value } }

    if (route === 'desdeDate') {
      newVariables = { ...newVariables, ...{ 'documentDate': value } }
    }
    if (route == "rate") {
      const localAmount =
        parseFloat(
          String(variables.originalAmount || 0)
            .replace(/[^0-9,]/g, "")
            .replace(/,/g, ".")
        ) *
        parseFloat(
          String(value || 0)
            .replace(/[^0-9,]/g, "")
            .replace(/,/g, ".")
        );
      newVariables = {
        ...newVariables,
        ...{ amount: Math.round(localAmount) },
      };
    }

    if (route == "originalAmount" && variables.rate) {
      const localAmount =
        parseFloat(value) *
        parseFloat(variables.rate)
      if (variables.currency === 'CLP') {
        newVariables = {
          ...newVariables,
          [route]: value.replace(/[.,]/g, ''),
          ...{ amount: Math.round(localAmount) },
        };
      } else {
        newVariables = {
          ...newVariables,
          ...{ amount: Math.round(localAmount) },
        };
      }
    }

    if (route === 'rate' && variables.originalAmount) {
      const localAmount =
        parseFloat(variables.originalAmount) *
        parseFloat(value)
      if (variables.currency === 'CLP') {
        newVariables = {
          ...newVariables,
          [route]: value.replace(/[.,]/g, ''),
          ...{ amount: Math.round(localAmount) },
        };
      } else {
        newVariables = {
          ...newVariables,
          ...{ amount: Math.round(localAmount) },
        };
      }
    }

    setVariables(newVariables)
  }

  const onSelectIssuer = (issuer) => {
    const selectedIssuer = options.find((option) => option.key == issuer.value);
    setIssuer(selectedIssuer);

    onChange(issuer.name, issuer.value);
  }

  const onSearchContraparte = (inputSearch = '') => {
    setGetAgendasInput(prev => ({ ...prev, search: inputSearch }))
  }

  const getContraparteName = async () => {
    const rutSearch = getAgendasInput.search;

    const { data, error } = await findCompanyName({ rut: rutSearch });

    if (error) return;

    if (!data && data === "no") return;

    setNameFound(data.findCompanyName)
  }

  useEffect(() => {
    if (nameFound) {
      const rutSearch = getAgendasInput.search;
      const newPerson = {
        id: "add",
        key: "add",
        value: "add",
        text: `${formatRut(rutSearch)} ${nameFound}`,
        label: "(+)",
      };
      const newOptions = [newPerson]
      setOptions(newOptions);

      setVariables({ ...variables, name: nameFound, rut: rutSearch })
    } else {
      setOptions([baseOptions]);
    }
  }, [nameFound])

  useEffect(() => {
    if (variables.rut === "add") return;
    onSearchContraparte(cleanRut(variables.rut));
  }, [variables.rut])

  const match = async () => {
    if (source !== "editObligation" && isCrearObligacionBlocked()) return;
    setLoading(true)
    let error = false

    let newObligation = parseObligation(
      variables,
      companyId,
      contacts,
      type,
      editData
    )

    dispatch(
      importAlertState({
        content: editData
          ? `Matcheando...`
          : "Creando Obligación...",
        state: "loading",
        duration: 5,
      })
    );

    let createdAgendaId = null;

    if (variables.issuerId === "add") {
      const newAgendaContact = {
        companyId,
        isClient: variables.isReceived ? false : true,
        isProvider: variables.isReceived ? true : false,
        name: variables?.name,
        rut: variables?.rut,
        paymentDaysClient: 30,
        paymentDaysProvider: 30,
      };

      const { error, data: createAgendaData } = await createAgenda({ input: newAgendaContact });

      if (error) {
        setLoading(false);

        return dispatch(
          importAlertState({
            content: `Ha ocurrido un error inesperado. Si persiste, comuníquese por Chat con nuestro equipo.`,
            state: "error",
            duration: 5,
          })
        );
      }

      if (createAgendaData?.createAgenda?.status === false) {
        setLoading(false);

        return dispatch(
          importAlertState({
            content: createAgendaData?.createAgenda?.message,
            state: "error",
            duration: 5,
          })
        );
      }

      if (createAgendaData?.createAgenda?.status === true) {
        createdAgendaId = createAgendaData.createAgenda.agenda.id;
        dispatch(
          importAlertState({
            content: `Contacto creado en la agenda.`,
            state: "success",
            duration: 4,
          })
        );
      }
    }

    // Agregar counterpartId a la obligación si se creó un nuevo contacto o se seleccionó uno existente
    if (!newObligation.meta) {
      newObligation.meta = {};
    }
    
    if (createdAgendaId) {
      newObligation.meta.counterpartId = createdAgendaId;
    } else if (variables.issuerId && variables.issuerId !== 'add') {
      newObligation.meta.counterpartId = variables.issuerId;
    }

    const { data: obligResponse, error: obligError } = await createObligation({
      input: newObligation,
      isDte: true,
    });

    setLoading(false)
    dispatch(importOpenSidebar({ show: false }));

    if (!obligError) {
      if (!editData) {
        dispatch(importUpdateNominaData(true))
        dispatch(importOpenSidebar({ show: false }))
        dispatch(setUpdateDocuments({ value: true }))
        dispatch(importUpdateCashFlow(true))
        dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
        dispatch(importEERRUpdateNeeded({ value: true, reload: null }))
        return dispatch(
          importAlertState({
            content: `Obligación creada con éxito.`,
            state: "success",
            duration: 4,
          })
        );
      }

      const endId = source == 'documents' ? editData._id : obligResponse.createObligationDocument.id
      const endType = source == 'documents' ? editData.documentType : DocumentType.OBLIGATION
      const end = [{
        endId,
        endType,
        currency: newObligation.currencyType || 'CLP',
        originalAmount: newObligation.meta?.remaining,
        amount: newObligation.currencyType == 'CLP' ? newObligation.meta?.remaining : newObligation.meta?.remaining * newObligation.meta?.rate,
      }]

      const origin = selected
        ? selected.map(t => ({ originType: 'TRANSACTION', originId: t.id, amount: t.remaining }))
        : [{
          originId: source == "documents" ? obligResponse.createObligationDocument.id : editData.id,
          originType: source == "documents" ? DocumentType.OBLIGATION : 'TRANSACTION',
          amount: newObligation.amount,
          originalAmount: newObligation?.meta?.originalAmount || newObligation.amount,
          currency: newObligation?.currencyType
        }]

      const input = {
        companyId,
        accountPlan: "NOPLAN",
        origin,
        end
      }

      const { error: matchError } = await generateMultipleMatch({ input })

      if (matchError) {
        setLoading(false);
        dispatch(importOpenSidebar({ show: false }));
        dispatch(
          importAlertState({
            content: `Hubo un problema al hacer el match.`,
            state: "error",
            duration: 4,
          })
        );

        error = true;
      }

      setLoading(false);
    } else {
      setLoading(false);

      dispatch(
        importAlertState({
          content: `Hubo un problema al crear la obligación.`,
          state: "error",
          duration: 4,
        })
      );

      error = true;
    }

    if (!error) {
      setLoading(false);
      if (setSelected) setSelected([])
      dispatch(importOpenSidebar({ show: false }));
      dispatch(setUpdateDocuments({ value: true }))
      dispatch(importUpdateCashFlow(true))
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      dispatch(updateConcilieantionRatio())
      return dispatch(
        importAlertState({
          content: `Match realizado!.`,
          state: "success",
          duration: 4,
        })
      );
    }
  }

  const editObligation = async () => {
    setLoading(true);

    try {
      const editedObligation = parseObligation(
        variables,
        companyId,
        contacts,
        type,
        editData
      );

      const result = await UpdateObligation({ id: (editData?._id || editData?.id), input: editedObligation });
      
      // Verificar diferentes estructuras de respuesta posibles
      const hasSuccess = result?.data?.editObligationDocument || 
                        result?.data?.editObligationDocument?.id ||
                        (result?.data && !result?.error);
      
      if (hasSuccess) {
        dispatch(
          importAlertState({
            content: `Obligación editada con éxito.`,
            state: "success",
            duration: 4,
          })
        );
        dispatch(setUpdateDocuments({ value: true }))
        dispatch(importUpdateCashFlow(true))
        dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
        dispatch(importOpenSidebar({ show: false }));
      } else if (result?.error) {
        console.error('Error al editar obligación:', result.error);
        dispatch(
          importAlertState({
            content: `Hubo un error al editar la obligación: ${result.error.message || 'Error desconocido'}`,
            state: "error",
            duration: 4,
          })
        );
      } else {
        // Caso donde no hay data ni error explícito - pero la operación puede haber sido exitosa
        console.warn('Respuesta inesperada al editar obligación:', result);
        // Asumir éxito si no hay error explícito
        dispatch(
          importAlertState({
            content: `Obligación editada con éxito.`,
            state: "success",
            duration: 4,
          })
        );
        dispatch(setUpdateDocuments({ value: true }))
        dispatch(importUpdateCashFlow(true))
        dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
        dispatch(importOpenSidebar({ show: false }));
      }
    } catch (error) {
      console.error('Error al editar obligación:', error);
      dispatch(
        importAlertState({
          content: `Hubo un error inesperado al editar la obligación: ${error?.message || 'Error desconocido'}`,
          state: "error",
          duration: 4,
        })
      );
    } finally {
      // Siempre limpiar el loading, sin importar el resultado
      setLoading(false);
    }
  };

  const deleteObligation = async () => {
    const { canDelete, nominaNames } = getDocumentsInNominaInfo(editData || {});
    if (!canDelete && nominaNames.length > 0) {
      setShowNominaGuardModal(true);
      return;
    }

    const title = `Eliminar ${editData?.meta?.type == 'proyeccion' ? 'Proyección' : 'Documento(s)'}`
    const content = `¿Está seguro que deseas eliminar esta ${editData?.meta?.type == 'proyeccion' ? 'Proyección' : 'Obligación'}?`
    const subcontent = editData?.meta?.type == 'proyeccion' ? '' : `Se eliminarán los Matches relacionados a esta obligación.`
    const subsubcontent = editData?.meta?.type == 'proyeccion' ? '' : `Documentos Tributarios podrían volver a aparecer.`

    dispatch(
      importNewModal({
        show: true,
        title,
        content,
        subcontent,
        subsubcontent,
        onConfirm: async () => {
          dispatch(
            importAlertState({
              content: `Estamos actualizando su información`,
              state: "loading",
              duration: 10,
            })
          );

          const input = {
            id: editData?.id || editData?._id,
            recurringId: variables.isMassive === true ? editData?.recurringId : ""
          }
          const result = await deleteDocuments({
            companyId,
            input: [input],
          });
          if (result?.data?.deleteDocument) {
            dispatch(
              importAlertState({
                content: `Obligación eliminada con éxito.`,
                state: "success",
                duration: 4,
              })
            );
            setLoading(false);
            dispatch(importOpenSidebar({ show: false }));
            dispatch(importUpdateNeeded({ value: true }));
            dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
          } else if (result.error) {
            // El backend dice por qué no se pudo (nómina, período cerrado, conciliación).
            dispatch(
              importAlertState({
                content:
                  result.error.graphQLErrors?.[0]?.message || `Hubo un error al eliminar la obligación.`,
                state: "error",
                duration: 8,
              })
            );
            setLoading(false);
          }
          dispatch(importNewModal({ show: false }));
        },
      })
    );
  };

  const goBack = () => {
    setVariables({ ...variables, ...{ issuerId: "", rut: "", name: "" } });
    setIssuer({});
  };

  const manageCurrencyIcon = {
    USD: "dollar",
    EUR: "euro",
    CLP: "dollar",
    GBP: "pound",
    MXN: "dollar",
  };

  let finished;
  if (opciones?.source == "nominas")
    finished =
      variables.type &&
      variables.documentDate &&
      (variables.amount || variables.originalAmount) &&
      ((variables.issuerId && variables.issuerId != "add") ||
        (variables.rut && variables.name));
  else {
    if (variables.issuerId == "add")
      finished =
        variables.type &&
        variables.documentDate &&
        (variables.amount || variables.originalAmount) &&
        variables.issuerId &&
        variables.rut &&
        variables.name;
    else
      finished = variables.type && variables.documentDate && (variables.amount || variables.originalAmount);
  }

  const handleCurrency = (value) => {
    onChange("currency", value)
  }

  const { nominaNames: guardNominaNames } = getDocumentsInNominaInfo(editData || {});

  return (
    <>
    <Form widths="equal">
      <Form.Checkbox
        toggle
        label="Por Pagar"
        name="isReceived"
        className={`d-flex justify-content-end obligationCheckBoxToggleLabelChecked ${variables.isReceived ? "" : "obligationCheckBoxToggleLabelUnchecked"
          }`}
        value={variables.isReceived}
        checked={variables.isReceived}
        onChange={(_, v) => onChange(v.name, v.checked)}
      />
      <Form.Field
        className="w-100"
        label="OBLIGACIÓN A CREAR"
        name="type"
        disabled={source == 'editObligation'}
        control={() => (
          <ObligacionesDropdown
            onChange={(_, v) => onChange(v.name, v.value)}
            value={variables.type}
            open={typeDropdownOpen}
            onOpen={() => setTypeDropdownOpen(true)}
            onClose={() => setTypeDropdownOpen(false)}
          />
        )}
        required
        fluid
      />

      <Form.Field
        label="ÁREA FLUJO DE CAJA"
        hidden={companyPlans.includes(Plans.flujo_de_caja) == false && !FULL_ACCESS_PLANS.some(p => companyPlans.includes(p))}
        className="mb-1"
      />
      <div
        className="mb-3"
        hidden={companyPlans.includes(Plans.flujo_de_caja) == false && !FULL_ACCESS_PLANS.some(p => companyPlans.includes(p))}
      >
        <CashflowAreaDropdown
          editData={{ cashflowAreaId: editData?.cashflowAreaId }}
          onChange={v => onChange("cashflowAreaId", v)}
        />
      </div>

      {/* {(!plan.includes(Plans.smartcfo)) ?
        companyPlans.includes(Plans.estado_de_resultados) == false && !FULL_ACCESS_PLANS.some(p => companyPlans.includes(p)) ? [] :


          <Form.Field
            label="ÁREA ESTADO DE RESULTADOS"
            hidden={companyPlans.includes(Plans.estado_de_resultados) == false && !FULL_ACCESS_PLANS.some(p => companyPlans.includes(p))}
            style={{ display: companyPlans.includes(Plans.estado_de_resultados) == false && !FULL_ACCESS_PLANS.some(p => companyPlans.includes(p)) ? 'none' : '' }}
            className="mb-3"
            control={() => (
              <SelectorEERR
                value={variables.fieldKey}
                onChange={(_, v) => onChange("fieldKey", v.value)}
                style={{ display: companyPlans.includes(Plans.estado_de_resultados) == false && !FULL_ACCESS_PLANS.some(p => companyPlans.includes(p)) ? 'none' : '' }}
                placeholder="Seleccione Área..."
                companyId={companyId}
              />
            )}
          />
        : ''} */}

      <Form.Dropdown
        selectOnBlur={false}
        className="w-100"
        label="TIPO"
        name="tipo"
        placeholder="Seleccione Tipo"
        options={tipoRecurrencia}
        onChange={(_, v) => {
          onChange(v.name, v.value);
        }}
        value={editData?.recurringId ? 'recurrente' : variables.tipo}
        disabled={source === 'editObligation' || editData?.meta?.tipo || fastObligation}
        selection
        search
        fluid
        required
      />
      {(variables.tipo === 'unico' ? <>
        <Form.Field
          className="w-100"
          label="FECHA"
          name="documentDate"
          type="date"
          control={Input}
          onChange={(_, v) => onChange(v.name, v.value)}
          value={variables.documentDate}
          required
        />
      </> : <>
        <Form.Dropdown
          selectOnBlur={false}
          className="w-100"
          label="REPETIR"
          name="repeat"
          placeholder="Seleccione recurrencia"
          options={repeatOptions}
          onChange={(_, v) => {
            onChange(v.name, v.value);
          }}
          value={variables.repeat}

          selection
          search
          fluid
          required
        />
        <Form.Group widths="equal">
          <Form.Field
            className="w-100"
            label="DESDE"
            name="desdeDate"
            type="date"
            control={Input}
            onChange={(_, v) => onChange(v.name, v.value)}
            value={variables.desdeDate}
            max={variables.hastaDate}
            required
          />
          <Form.Field
            className="w-100"
            label="HASTA"
            name="hastaDate"
            type="date"
            control={Input}
            onChange={(_, v) => onChange(v.name, v.value)}
            value={variables.hastaDate}
            min={variables.desdeDate}
            required
          />
        </Form.Group>
        {
          variables?.desdeDate > variables?.hastaDate ? (
            <Label className="w-100 text-center mb-3">
              La fecha de Inicio no puede ser
              mayor a la fecha Final
            </Label>
          ) : (
            ""
          )}


      </>)}

      <Form.Input
        className="w-100"
        label="MONTO"
        name="originalAmount"
        disabled={isAmountDisabled}
        icon={manageCurrencyIcon[variables.currency] || "dollar"}
        iconPosition="left"
        placeholder="Ingrese Monto..."
        inputMode="numeric"
        type="number"
        value={(variables.originalAmount) || ""}
        onChange={(_, v) => onChange(v.name, v.value)}
        action={
          <CurrencyDropdown value={variables.currency || "us"} onChange={handleCurrency} floating button basic disabled={fastObligation} />
        }
        required
        fluid
      />
      {currencyOptionsWithSpecials.filter(c => c.key !== 'CLP').map(c => c.key).includes(variables.currency) ? (
        <>
          <Form.Group className="w-100 mb-2" widths="equal" inline>
            <Form.Field
              className="w-100"
              label="TIPO DE CAMBIO"
              name="rate"
              control={Input}
              icon="dollar"
              inputMode="numeric"
              type="number"
              iconPosition="left"
              placeholder="Ingrese Tipo de Cambio..."
              onChange={(_, v) => onChange(v.name, v.value)}
              value={(variables.rate) || ""}
              fluid
              required
            />
            <Form.Field
              className="w-100 ml-2"
              label="MONTO EN PESOS"
              name="amount"
              control={Input}
              icon="dollar"
              iconPosition="left"
              placeholder="Monto en pesos..."
              //value={formatNewMoney(Math.round(parseInt(variables.amount || "")))}
              value={formatNewMoney(Math.round(variables.originalAmount * variables.rate))}
              fluid
              disabled
            />
          </Form.Group>
          <Form.Field
            className="w-100 mb-3"
            label="NÚMERO DE REFERENCIA"
            name="referenceNumber"
            control={Input}
            placeholder="Número de referencia..."
            onChange={(_, v) => onChange(v.name, v.value)}
            value={variables.referenceNumber}
          />
        </>
      ) : (
        ""
      )}
      {variables.issuerId == "add" ? (
        <Form.Group widths="equal" inline>
          <Form.Field
            label={variables.type == "invoice" ? "TAX ID" : "RUT"}
            control={Input}
            placeholder={
              variables.type == "invoice" ? "Ingrese TAX ID" : "Ingrese RUT"
            }
            name="rut"
            value={formatRut(variables.rut)}
            onChange={(_, v) =>
              onChange(v.name, v.value.replace(/[^0-9Kk]/g, ""))
            }
            maxLength={12}
            className="w-100"
            required
            fluid
          />
          <Form.Field
            label="NOMBRE"
            name="name"
            control={Input}
            placeholder="Ingrese Nombre"
            value={variables.name}
            onChange={(_, v) => onChange(v.name, v.value)}
            className="w-100 ml-2"
            required
            fluid
          />
          <div className="d-flex justify-content-center align-items-center h-100">
            <Icon
              style={{
                fontSize: "1.5em",
                marginTop: "50%",
                marginLeft: "2px",
                cursor: "pointer",
              }}
              onClick={goBack}
              name="remove circle"
              color="blue"
              size="big"
            />
          </div>
        </Form.Group>
      ) : (
        <Form.Dropdown
          selectOnBlur={false}
          className="w-100"
          label="CONTRAPARTE"
          name="issuerId"
          placeholder="Ingrese Contraparte"
          options={options}
          onChange={(_, v) => {
            onSelectIssuer(v);
          }}
          value={variables.issuerId}
          onSearchChange={(_, v) => onSearchContraparte(v.searchQuery)}
          selection
          search={(opt, query) => { return opt }}
          fluid
          required={opciones?.source === "nominas" ? true : false}
          onBlur={() => {
            onSearchContraparte('');
          }}
          noResultsMessage="No se encontraron resultados."
        />
      )}
      <Form.Field
        className="w-100"
        label="DESCRIPCIÓN"
        name="description"
        control={Input}
        placeholder="Ingrese Descripción (Opcional)..."
        onChange={(_, v) => onChange(v.name, v.value)}
        value={variables.description}
        fluid
      />
      <Form.Field
        className="w-100"
        label="NÚMERO O FOLIO"
        name="documentId"
        control={Input}
        placeholder="Ingrese Número o Folio (Opcional)..."
        onChange={(_, v) => onChange(v.name, v.value)}
        value={variables.documentId}
        fluid
      />
      {source === 'editObligation' && editData?.recurringId &&
        <Form.Field
          className="w-100 text-dark"
          control={Checkbox}
          name="isMassive"
          onChange={(_, v) => onChange(v.name, v.checked)}
          value={variables.isMassive}
          label='Aplicar para este y los futuros eventos'
          fluid
        />}
      <div className="d-flex justify-content-center mt-4 mb-2">
        <Button
          type="button"
          color="blue"
          onClick={source === "editObligation" ? editObligation : match}
          disabled={!finished || loading || fetchingAgendaData}
          loading={loading}
        >
          {source == "documents"
            ? "Match"
            : source == "editObligation"
              ? "Guardar Cambios"
              : "Crear"}
        </Button>
        {source === "editObligation" && (
          <Button
            type="button"
            onClick={deleteObligation}
            disabled={!finished}
            loading={deleteLoading}
            style={{ marginLeft: "10px" }}
          >
            Eliminar
          </Button>
        )}
      </div>
    </Form>
    <CustomModal
      open={showNominaGuardModal}
      onClose={() => setShowNominaGuardModal(false)}
      title="No se puede eliminar el documento"
      content={
        <div className="tw-p-2">
          <p className="tw-mb-2">
            Este documento no puede ser eliminado porque se encuentra en {guardNominaNames.length === 1 ? 'la siguiente nómina' : 'las siguientes nóminas'}:
          </p>
          <ul className="tw-list-disc tw-pl-5 tw-mb-2">
            {guardNominaNames.map((name, i) => (
              <li key={i} className="tw-font-semibold">{name}</li>
            ))}
          </ul>
          <p className="tw-text-sm tw-text-gray-600">
            Debe quitar el documento de {guardNominaNames.length === 1 ? 'la nómina' : 'las nóminas'} antes de poder eliminarlo.
          </p>
        </div>
      }
      customActions={
        <Button onClick={() => setShowNominaGuardModal(false)}>Entendido</Button>
      }
    />
    </>
  );
};

export default CrearObligacion;
